module.exports = __webpack_public_path__ + "static/6971291427-thumnail-726e7dae7530bd7e049fde8d7e898a25.jpeg";